/**
 * SPDX-FileCopyrightText: (c) 2026 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import Button, {IProps} from './Button';
import ClayButtonWithIcon, {Props} from './ButtonWithIcon';

export type {Props as ButtonWithIconProps, IProps as ButtonProps};
export {ClayButtonWithIcon};
export default Button;
